var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.8@core-js/library/modules/_uid.js
// module id = 42
// module chunks = 0